/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
var React = require("react");
var IconSVG = /** @class */ (function (_super) {
    tslib_1.__extends(IconSVG, _super);
    function IconSVG() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconSVG.prototype.render = function () {
        return (React.createElement("svg", tslib_1.__assign({ role: "img", viewBox: "0 0 80 80" }, this.props),
            React.createElement("path", { d: "m40.5 3c16.817 0 29.5 13.43 29.5 31.239 0 9.468-4.839 19.678-14.382 30.348-7.026 7.855-13.945 12.915-14.236 13.127-.263.19-.572.286-.882.286s-.619-.096-.882-.286c-.291-.212-7.21-5.272-14.236-13.127-9.543-10.67-14.382-20.88-14.382-30.348 0-17.809 12.683-31.239 29.5-31.239zm0 71.615c4.695-3.655 26.5-21.643 26.5-40.376 0-16.099-11.393-28.239-26.5-28.239s-26.5 12.14-26.5 28.239c0 18.733 21.805 36.721 26.5 40.376zm0-59.093c9.404 0 17.056 7.694 17.056 17.152s-7.652 17.152-17.056 17.152-17.055-7.694-17.055-17.152 7.651-17.152 17.055-17.152zm0 31.304c7.75 0 14.056-6.349 14.056-14.152 0-7.804-6.306-14.152-14.056-14.152s-14.055 6.348-14.055 14.152c0 7.803 6.305 14.152 14.055 14.152z" })));
    };
    return IconSVG;
}(React.Component));
exports.IconSVG = IconSVG;